import {
    Component,
    OnInit,
    OnDestroy,
    ViewChild,
    ElementRef,
    Input,
    AfterViewInit,
    Renderer2,
} from "@angular/core"
import { BrowsingService } from "../../services/browsing.service"
import { CHNode } from "../../models/node.model"
import { Subscription } from "rxjs"
import { UserService } from "../../services/user.service"

@Component({
    selector: "app-browse-by",
    templateUrl: "./browse-by.component.html",
    styleUrls: ["./browse-by.component.scss"],
})
export class BrowseByComponent implements OnInit, OnDestroy, AfterViewInit {
    public activeNode: CHNode
    public subscriptions: Subscription[] = []
    public disciplines: CHNode[] = []
    public view: number = 1
    public mobileSubjectTitle: string = ""
    public view3Discipline: any = null
    public gtmPrefix: string = "gtm-browse-by-section-"

    @Input() setOn: string = "any" // can be homepage
    @Input() mobileView: boolean = false
    @ViewChild("fakeView") fakeView: ElementRef

    public colorClasses: any[] = [
        {
            disciplineID: 8337,
            className: "science-color",
        },
        {
            disciplineID: 3026,
            className: "social-color",
        },
        {
            disciplineID: 1184,
            className: "math-color",
        },
        {
            disciplineID: 1880,
            className: "ela-color",
        },
        {
            disciplineID: 8353,
            className: "tech-color",
        },
        {
            disciplineID: 2806,
            className: "health-color",
        },
        {
            disciplineID: 2949,
            className: "prek-color",
        },
        {
            disciplineID: 6708,
            className: "prof-color",
        },
        {
            disciplineID: 2663,
            className: "arts-color",
        },
        {
            disciplineID: 6267,
            className: "languages-color",
        },
    ]

    constructor(
        private browsingService: BrowsingService,
        private renderer: Renderer2,
        private element: ElementRef,
        private userService: UserService
    ) {}

    ngOnInit() {
        this.subscriptions.push(
            this.browsingService.getSubjectsTree().subscribe(
                (data: any) => {
                    this.disciplines = data
                },
                (error) => console.error(`[CUSTOM Error]${error}`)
            )
        )
    }

    ngAfterViewInit() {
        this.fixHeight()
    }

    getAvailableSubjects(discipline) {
        return discipline.children.filter((node) => node.resultsCount > 0)
    }

    ngOnDestroy() {
        this.subscriptions.map((subscription) => subscription.unsubscribe())
    }

    setView(view: number, subjectTitle: string = "", discipline: any = null) {
        this.view = view
        this.fixHeight()
        this.mobileSubjectTitle = subjectTitle
        if (discipline) {
            this.view3Discipline = discipline
        }
    }

    private fixHeight() {
        setTimeout(() => {
            let view = ".view" + this.view
            let viewEl = this.element.nativeElement.querySelector(view)
            if (viewEl) {
                let h = viewEl.offsetHeight.toString()
                this.renderer.setAttribute(
                    this.fakeView.nativeElement,
                    "style",
                    "height:" + h + "px"
                )
            }
        }, 1)
    }

    public getColorClass(discipline: any) {
        return { [this.getColorClassString(discipline)]: true }
    }

    public getColorClassString(discipline: any) {
        let itemClass = ""
        this.colorClasses.map((colorClass) => {
            if (discipline.id === colorClass.disciplineID) {
                itemClass = colorClass.className
            }
        })
        return itemClass
    }
}
